'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Ajax = function () {
  function Ajax() {
    _classCallCheck(this, Ajax);
  }

  _createClass(Ajax, [{
    key: 'httpRequest',
    value: function httpRequest() {
      return new XMLHttpRequest();
    }
  }, {
    key: 'send',
    value: function send(url, callback, method) {
      var httpRequest = this.httpRequest();
      httpRequest.open(method, url);
      httpRequest.onreadystatechange = function () {
        if (httpRequest.readyState === 4 && httpRequest.status === 200) {
          try {
            var data = JSON.parse(httpRequest.responseText);
            callback(data);
          } catch (error) {
            console.log(error.message + ' in ' + httpRequest.responseText);
            return;
          }
        }
      };

      httpRequest.send();
    }
  }, {
    key: 'get',
    value: function get(url, callback) {
      this.send(url, callback, 'GET');
    }
  }]);

  return Ajax;
}();

exports.default = new Ajax();
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/utils/Ajax.js
// module id = 0
// module chunks = 1 2